module.exports = __webpack_public_path__ + "static/media/蓝牙防丢器.47d4aec2.png";